import CondtionalRouterLink from './CondtionalRouterLink.vue';

export default CondtionalRouterLink;
